(() => {
  let dispose;
  function init() {
    dispose?.();
    const header = document.querySelector('store-header');
    const toggle = header?.querySelector('.gm-category-toggle');
    const panel = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const originalParent = panel.parentNode;
    const backdrop = document.createElement('div');
    backdrop.className = 'gm-category-backdrop'; backdrop.hidden = true;
    document.body.append(backdrop, panel);
    const controller = new AbortController();
    const listen = (el, event, fn) => el.addEventListener(event, fn, { signal: controller.signal });
    let opened = false, timer;
    function position() {
      const top = Math.max(0, header.getBoundingClientRect().bottom);
      panel.style.setProperty('--gm-category-top', `${top}px`);
      backdrop.style.top = `${top}px`;
    }
    function close(focus = false, immediate = false) {
      if (!opened && !immediate) return;
      opened = false; clearTimeout(timer);
      toggle.setAttribute('aria-expanded', 'false');
      header.classList.remove('gm-category-open');
      document.dispatchEvent(new Event('gm:category-change'));
      panel.classList.remove('is-open'); backdrop.classList.remove('is-open');
      const finish = () => {
        panel.hidden = backdrop.hidden = true;
        document.body.classList.remove('gm-category-menu-open');
      };
      if (immediate || matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else timer = setTimeout(finish, 200);
      if (focus) toggle.focus();
    }
    function open() {
      if (!matchMedia('(min-width:769px)').matches) return;
      clearTimeout(timer); opened = true;
      header.classList.add('gm-category-open');
      document.dispatchEvent(new Event('gm:category-change'));
      document.body.classList.add('gm-category-menu-open');
      position(); panel.hidden = backdrop.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => { if (opened) { panel.classList.add('is-open'); backdrop.classList.add('is-open'); } });
    }
    listen(toggle, 'click', () => opened ? close() : open());
    listen(toggle, 'keydown', event => {
      if (event.key === 'ArrowDown' || (event.key === 'Tab' && !event.shiftKey && opened)) {
        event.preventDefault(); open(); requestAnimationFrame(() => { if (opened) panel.querySelector('a')?.focus(); });
      }
    });
    listen(document, 'keydown', event => { if (opened && event.key === 'Escape') { event.preventDefault(); close(true); } });
    listen(document, 'click', event => { if (opened && !panel.contains(event.target) && !toggle.contains(event.target)) close(); });
    listen(document, 'focusin', event => { if (opened && !panel.contains(event.target) && event.target !== toggle) close(); });
    listen(panel, 'click', event => { if (event.target.closest('a')) close(false, true); });
    listen(window, 'scroll', () => { if (opened) position(); });
    listen(window, 'resize', () => { if (innerWidth <= 768) close(false, true); else if (opened) position(); });
    listen(window, 'pageshow', () => close(false, true));
    const resizeObserver = new ResizeObserver(() => { if (opened) position(); });
    resizeObserver.observe(header);
    dispose = () => { close(false, true); controller.abort(); resizeObserver.disconnect(); backdrop.remove(); originalParent.append(panel); };
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
